import classNames from 'classnames';
import styled, { CSSProperties, css, keyframes } from 'styled-components';

import { Horizontal, Vertical } from 'atoms/layout/flex';
import { range } from 'lib/arrays';

const rollingUp = keyframes`
  to {
    top: calc(-1 * var(--elements-count) * 100%);
  }
`;
const rollingDown = keyframes`
  to {
    bottom: calc(var(--elements-count) * -1 * 100%);
  }
`;

const minSize = css`
  min-height: calc(8 * var(--unit));
  min-width: calc(8 * var(--unit));
`;

const Root = styled.div`
  position: relative;
  overflow: hidden;
  width: 100%;
  height: 100%;
  ${minSize}
`;
const Display = styled(Vertical).attrs({ gap: 0 })`
  --elements-count: 1;

  position: absolute;
  left: 50%;
  transform: translateX(-50%);

  &.up {
    top: 0;
    animation: ${rollingUp} 0.8s cubic-bezier(0.65, 0, 0.24, 1.22) forwards;
  }
  &.down {
    flex-direction: column-reverse;
    bottom: 0;
    animation: ${rollingDown} 0.8s cubic-bezier(0.65, 0, 0.24, 1.22) forwards;
  }
`;
const Element = styled(Horizontal).attrs({ center: true })`
  ${minSize}
`;

export enum RollingDirection {
  UP,
  DOWN,
}

type Props = {
  before: number;
  after: number;
  rollingDirection?: RollingDirection;
  initialDelay?: string;
  className?: string;
};
export const RollingNumber = ({
  before,
  after,
  rollingDirection = RollingDirection.UP,
  initialDelay,
  className,
}: Props) => {
  const desc = after < before;
  const elementsCount = Math.abs(after - before) + 1;

  return (
    <Root className={className}>
      <Display
        className={classNames({
          up: rollingDirection === RollingDirection.UP,
          down: rollingDirection === RollingDirection.DOWN,
        })}
        style={
          {
            animationDelay: initialDelay,
            '--elements-count': elementsCount - 1,
          } as CSSProperties
        }
      >
        {range(elementsCount).map(i => {
          const number = before + (desc ? -1 : 1) * i;
          return <Element key={number}>{number}</Element>;
        })}
      </Display>
    </Root>
  );
};
